import { render, staticRenderFns } from "./PanelLogout.vue?vue&type=template&id=79f6ab16&scoped=true&"
import script from "./PanelLogout.vue?vue&type=script&lang=js&"
export * from "./PanelLogout.vue?vue&type=script&lang=js&"
import style0 from "./PanelLogout.vue?vue&type=style&index=0&id=79f6ab16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f6ab16",
  null
  
)

export default component.exports